import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postUnmarkProjectAsUninactive = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}projects/markunfinished/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

export default postUnmarkProjectAsUninactive;
